/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * * `worksheet` - Worksheet * `worksheet_all` - Worksheet All * `all_tips_audio` - All tips audio * `video` - Video * `category_explanation` - Explanation * `tip` - Tip * `consulting_tip` - Consulting tip * `rich_text` - Rich text
 */
export type EduActivityActivityTypeEnum = 'worksheet' | 'worksheet_all' | 'all_tips_audio' | 'video' | 'category_explanation' | 'tip' | 'consulting_tip' | 'rich_text';

export const EduActivityActivityTypeEnum = {
    Worksheet: 'worksheet' as EduActivityActivityTypeEnum,
    WorksheetAll: 'worksheet_all' as EduActivityActivityTypeEnum,
    AllTipsAudio: 'all_tips_audio' as EduActivityActivityTypeEnum,
    Video: 'video' as EduActivityActivityTypeEnum,
    CategoryExplanation: 'category_explanation' as EduActivityActivityTypeEnum,
    Tip: 'tip' as EduActivityActivityTypeEnum,
    ConsultingTip: 'consulting_tip' as EduActivityActivityTypeEnum,
    RichText: 'rich_text' as EduActivityActivityTypeEnum
};